const LABELS = Object.freeze({
  pending: 'Queued',
  queued: 'Queued',
  processing: 'Processing',
  accepted: 'Sent',
  sent: 'Sent',
  delivered: 'Delivered',
  opened: 'Opened',
  clicked: 'Clicked',
  bounced: 'Bounced',
  complained: 'Complained',
  failed: 'Failed',
});

const PRIORITY = Object.freeze({
  pending: 10, queued: 10, processing: 20, accepted: 30, sent: 40,
  delivered: 50, opened: 60, clicked: 70,
  failed: 100, bounced: 100, complained: 100,
});

function validStatus(value) {
  const status = String(value || '').toLowerCase();
  return Object.prototype.hasOwnProperty.call(LABELS, status) ? status : null;
}

function deliveryStatusForDisplay(status) {
  return status === 'opened' || status === 'clicked' ? 'delivered' : status;
}

export function getMessageStatus(item) {
  const displayStatus = deliveryStatusForDisplay(validStatus(item?.displayStatus));
  if (displayStatus) return displayStatus;
  const deliveryStatus = deliveryStatusForDisplay(validStatus(item?.deliveryStatus));
  const sendStatus = validStatus(item?.status);
  if (!deliveryStatus) return sendStatus || 'pending';
  if (!sendStatus) return deliveryStatus;
  return PRIORITY[deliveryStatus] > PRIORITY[sendStatus] ? deliveryStatus : sendStatus;
}

export function getMessageStatusLabel(item) {
  return LABELS[getMessageStatus(item)];
}

export function getMessageStatusStyle(item) {
  const status = getMessageStatus(item);
  if (status === 'clicked') return { background: '#EDE9FE', color: '#5B21B6' };
  if (status === 'opened') return { background: '#DBEAFE', color: '#1E40AF' };
  if (status === 'delivered') return { background: '#D1FAE5', color: '#065F46' };
  if (status === 'failed' || status === 'bounced') return { background: '#FEE2E2', color: '#991B1B' };
  if (status === 'complained') return { background: '#FFEDD5', color: '#9A3412' };
  if (status === 'processing') return { background: '#E0E7FF', color: '#3730A3' };
  return { background: '#FEF3C7', color: '#92400E' };
}
